// Chọn khung cho khu vực đã đăng nhập: điện thoại luôn dùng Glass, máy tính dùng khung gốc. Hộp đánh giá khi đăng xuất
// (LogoutSurveyHost) đặt ở đây — dùng chung cho cả hai khung.

import { useViewportMode } from '@/hooks/useViewportMode'
import { LogoutSurveyHost } from '@/components/survey/LogoutSurvey'
import DashboardLayout from './DashboardLayout'
import GlassLayout from './GlassLayout'

export default function AppShell() {
  const viewport = useViewportMode()
  return (
    <>
      {viewport === 'mobile' ? <GlassLayout /> : <DashboardLayout />}
      <LogoutSurveyHost />
    </>
  )
}
